import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const GET_USER = gql`
  query User($userId: String!) {
    user(userId: $userId) {
      ...UserAccount
    }
  }
  ${fragments.userAccount}
`

export const GET_USERS = gql`
  query Users {
    users {
      ...UserAccount
    }
  }
  ${fragments.userAccount}
`

export const GET_GROUP_INVITATIONS = gql`
  query UserGroupInvitations {
    groupInvitations {
      ...UserGroupInvitation
    }
  }
  ${fragments.userGroupInvitation}
`

export const GET_IMAGE_UPLOAD_URL = gql`
  mutation imageUploadURL($id: String!, $imageType: ImageType!, $imageExtension: ImageExtension!) {
    imageUploadURL(id: $id, imageType: $imageType, imageExtension: $imageExtension) {
      url
      expires
    }
  }
`

export const RESEND_EMAIL = gql`
  mutation RESEND_EMAIL($oldEmail: String!, $newEmail: String!) {
    resendEmail(oldEmail: $oldEmail, newEmail: $newEmail)
  }
`

export const ADD_USER = gql`
  mutation AddUser($userInput: UserInput!) {
    addUser(userInput: $userInput) {
      ...UserAccount
    }
  }
  ${fragments.userAccount}
`

export const SAVE_USER = gql`
  mutation SaveUser($userId: String!, $userInput: UserInput!) {
    saveUser(userId: $userId, userInput: $userInput) {
      ...UserAccount
    }
  }
  ${fragments.userAccount}
`

export const LOGIN_EVENT_USER = gql`
  mutation SaveUser($userId: String!, $loginTime: Date!) {
    loginEvent(userId: $userId, loginTime: $loginTime)
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($userId: String!) {
    cleanupForUser(userId: $userId)
    deleteUser(userId: $userId)
  }
`

export const ACCEPT_GROUP_INVITATION = gql`
  mutation AcceptGroupInvitation($groupId: ID!) {
    acceptGroupInvitationAndJoinOwner(groupId: $groupId) {
      ...UserGroupInvitation
    }
  }
  ${fragments.userGroupInvitation}
`

export const ADD_GROUP_INVITATION = gql`
  mutation AddGroupInvitation($userEmail: String!, $guestName: String) {
    addGroupInvitation(userEmail: $userEmail, guestName: $guestName) {
      ...UserGroupInvitation
    }
  }
  ${fragments.userGroupInvitation}
`

export const DELETE_GROUP_MEMBER = gql`
  mutation DeleteGroupMember($userEmail: String!) {
    deleteGroupMember(userEmail: $userEmail)
  }
`

export const LEAVE_GROUP = gql`
  mutation LeaveGroup {
    leaveGroup
  }
`

export const SET_GROUP_NAME = gql`
  mutation SetGroupName($groupName: String!) {
    setGroupName(name: $groupName) {
      id
    }
  }
`

const mutations = {
  addRemote: ADD_USER,
  saveRemote: SAVE_USER,
  deleteRemote: DELETE_USER,
  saveOp: 'saveUser',
  addOp: 'addUser',
  deleteOp: 'deleteUser',
}

export const userQueries = { ...mutations, getRemote: GET_USER }
export const usersQueries = { ...mutations, getRemote: GET_USERS }
